module.exports = __webpack_public_path__ + "img/link.988d4a6f.png";